
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_45270","data-name":"Group 45270","transform":"translate(-1367 -199)"}},[_c('g',{attrs:{"id":"Group_45024","data-name":"Group 45024","transform":"translate(0 3)"}},[_c('circle',{attrs:{"id":"Ellipse_859","data-name":"Ellipse 859","cx":"12.5","cy":"12.5","r":"12.5","transform":"translate(1367 196)","fill":"#4bcca2"}}),_c('path',{attrs:{"id":"Positive_Icon","data-name":"Positive Icon","d":"M3.66 6.523a1.128 1.128 0 01-1.6 0L.33 4.79a1.129 1.129 0 011.6-1.6l.936.936 3.8-3.8a1.129 1.129 0 011.6 1.6z","transform":"translate(1375.203 205)","fill":"#fbfbfc"}})])])])
          )
        }
      }
    